module.exports = __webpack_public_path__ + "img/ico-alert.fbd33943.svg";